<div class="progress-bar" *ngIf="featureIndex > 0 || showProgressBar">
  <div class="progress-bar__container">
    <span class="progress-bar__title">{{panelConfig?.mainTitle}}</span>
    <span class="progress-bar__step" *ngIf="totalPages > 1">
      <span class="util-helper__hide-xs">Step</span>
      {{featureIndex}} of {{totalPages}}
    </span>
  </div>
</div>

<section class="section" [ngStyle]="{'background': showProgressBar ? 'transparent' : null}">
  <div id="resetFocus" tabindex="0"></div>
  <app-section-heading *ngIf="panelConfig.isVisible"
                       [mainTitle]="featureIndex > 0 ? '' : panelConfig?.mainTitle"
                       [subTitle]="panelConfig.subTitle"
                       [titleIcon]="titleIcon"
                       [policyId]="policyId"
                       [policyChangeDate]="policyChangeDate"
                       [isNotification]="panelConfig.isNotification"
                       [isShowPolicyNumber]="panelConfig.isShowPolicyNumber">
  </app-section-heading>
  <div [ngClass]="{'section__wrapper': panelConfig.isSectionWrapper}">
    <router-outlet>
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </router-outlet>
    <app-loading-indicator [isLoading]="isProgressing"></app-loading-indicator>
  </div>
</section>

<!-- Recommended by Okta: use hidden iframe to avoid CORS issue when receiving Okta Id -->
<app-hidden-iframe></app-hidden-iframe>
